import {Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges} from '@angular/core';
import {  Subject } from 'rxjs';
import {WidgetDialogService} from '../../../services/widget-dialog.service';
import {TranslateService} from '@ngx-translate/core';
import {AttachFileDialogResponse, IconType, IoniconsOutline, PtPermissions} from '@pt/pt-models';
import { Attachment } from 'it/primatoo/openapi/api/org/schemas/common/Attachment';

@Component({
  selector: 'pt-widget-attachment-editor-v0',
  template: `
    <div
      *ngIf='show'
      class='pt-widget-attachment-editor-v0'>

      <ng-template #NODATA>
        <pt-widget-nodata [noDataLabel]="noDataLabel"></pt-widget-nodata>
      </ng-template>

      <div class='attachments' *ngIf='currentAttachment?.length > 0 else NODATA'>
        <div class='mb-3' *ngFor='let attachment of currentAttachment'>
          <div class='attachment-container'>
            <pt-icon [size]='30'
                     [iconType]='SVG'
                     [key]='attachment?.attachmentType?.toLowerCase() + ".svg"'
            ></pt-icon>

            <div class='attachment'>
              <span [container]='"body"'
                    [ngbTooltip]='attachment?.name'>
                {{
                  attachment?.name ? attachment?.name :
                    ("MESSAGE.ATTACHMENT_WITHOUT_NAME" | translate)
                }}
              </span>

              <span class='checksum text-muted' container='body'
                    [ngbTooltip]='attachment?.checksum'
              >Checksum: {{ attachment?.checksum }}</span>
            </div>

            <div class='attachment-actions'>
              <button class='btn btn-sm btn-outline-danger d-flex align-items-end'
                      (click)='onDeleteAttachment(attachment)'>
                <pt-icon [key]='IconTrash'></pt-icon>
                <span>{{ "BUTTON.DELETE" | translate }}</span>
              </button>

              <button class='btn btn-sm btn-outline-secondary d-flex align-items-end ms-1'
                      (click)='downloadAttachment.emit(attachment)'>
                <pt-icon [key]='IconDownload'></pt-icon>
                <span>{{ "BUTTON.DOWNLOAD" | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div *ngxPermissionsOnly="PtPermissions.MANAGE_WORKSPACE">
        <pt-input-attachment
          [showDelete]='true'
          [showDownload]='false'
          [noAttachmentMessage]="'MESSAGE.ATTACHMENT_WITHOUT_NAME' | translate"
          [attachments]='[]'
          (attachAction)='addAttachment($event)'
          (deleteAttachment)='onDeleteAttachment($event)'
        ></pt-input-attachment>
      </div>
    </div>
  `,
  styles: [`
    .pt-widget-attachment-editor-v0 {
      border: solid 1px var(--ptBorder);
      padding: 10px 10px 10px 10px;
    }

    .attachments {
      overflow: auto;
      max-height: 156px;
    }

    .attachment-container {
      display: flex;
      align-items: center;
    }

    .attachment {
      padding: 0 5px 0 4px;
      display: grid;
    }

    .checksum {
      font-size: 10px;
    }

    .attachment-actions {
      display: flex;
      align-self: end;
    }

    span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  `]
})
export class WidgetAttachmentEditorV0Component implements OnChanges, OnDestroy {
  @Input() noDataLabel?: string;
  @Input() data: Attachment[];
  @Input() show: boolean;

  @Output() currentValue = new EventEmitter<Array<string>>();
  @Output() clickEditWidget = new EventEmitter<boolean>();
  @Output() clickResetWidget = new EventEmitter<boolean>();


  // @Output() attachAction: EventEmitter<AttachFileDialogResponse> = new EventEmitter<AttachFileDialogResponse>();
  @Output() deleteAttachment: EventEmitter<Attachment> = new EventEmitter<Attachment>();
  @Output() downloadAttachment: EventEmitter<Attachment> = new EventEmitter<Attachment>();

  currentAttachment: Attachment[];
  IconAttach = IoniconsOutline.attach;
  IconTrash = IoniconsOutline.trash;
  IconDownload = IoniconsOutline.download;
  SVG = IconType.SVG;
  public PtPermissions = PtPermissions;

  private destroy$ = new Subject();

  constructor(
    private widgetDialogService: WidgetDialogService,
    private translateService: TranslateService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && this.data?.length > 0) {
      this.currentAttachment = JSON.parse(JSON.stringify(this.data));
    } else {
      this.currentAttachment = [];
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  addAttachment(attachment?: AttachFileDialogResponse) {
    if (attachment && attachment.data) {
      this.currentAttachment.push(attachment.data);
      this.propagateChangeValue();
    } else {
      this.clickResetWidget.emit(true);
    }
  }

  onDeleteAttachment(attachment: Attachment) {
    this.currentAttachment = this.currentAttachment.filter(a => a.uuid !== attachment.uuid);
    this.propagateChangeValue();
  }

  propagateChangeValue() {
    const attachmentsId = this.currentAttachment.map(a => a.uuid);
    this.currentValue.emit(attachmentsId);
  }
}
